import React from 'react'

const mbplvCodes = ['MBFB', 'MBCOS', 'MBBMM', 'MBCOLO', 'MBFUC', 'MBFIGV', 'MBAO', 'MBFR', 'MBGUZ']
const makroCodes = ['B-1MKR', 'B-2MKR']

const modeBuyer = [
  {
    label: (e) => (<div
      style={{
        color: e ? '#3BB77E' : '#253d4e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }} 
    >
      All
    </div>),
    value: 'all',
    filterFunc: (e) => e,
  },
  {
    label: (e) => (<div
      style={{
        color: e ? '#3BB77E' : '#253d4e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }} 
    >
      MB FV
    </div>),
    value: 'mbfv',
    filterFunc: (e) => e?.slice(0,2)?.includes('MB') && !mbplvCodes?.includes(e), 
  },
  {
    label: (e) => (<div
      style={{
        color: e ? '#3BB77E' : '#253d4e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }} 
    >
      MB PLV
    </div>),
    value: 'mbplv',
    filterFunc: (e) => mbplvCodes?.includes(e),
  },
  {
    label: (e) => (<div
      style={{
        color: e ? '#3BB77E' : '#253d4e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }} 
    >
      Makro
    </div>),
    value: 'makro',
    filterFunc: (e) => makroCodes?.includes(e),
  },
  {
    label: (e) => (<div
      style={{
        color: e ? '#3BB77E' : '#253d4e',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }} 
    >
      BCN
    </div>),
    value: 'bcn',
    filterFunc: (e) => e?.slice(0,2)?.includes('B-'),
  },
]

export default modeBuyer